import React from 'react';
import { Icon } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';


function ScrollArrow() {
    return (
        <div class="contentDiv container-fluid h-10 dropshadow">
            <KeyboardDoubleArrowDownIcon color='white' className='arrow' />
        </div>
    );
}
export default ScrollArrow;